var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.total > 1)?_c('ul',{staticClass:"pagination"},[(_vm.currentPage > 1)?_c('router-link',{staticClass:"pagination__item pagination__item--prev",attrs:{"to":_vm.mkRouteObj(--_vm.currentPage)}},[_c('i',{staticClass:"fal fa-chevron-left"})]):_vm._e(),_vm._l((_vm.pagination),function(p,i){return _c('router-link',{key:i,class:[
      'pagination__item',
      'pagination__item--' + p.type,
      {
        'pagination__item--current': p.val == _vm.currentPage,
      },
    ],attrs:{"to":p.route}},[_vm._v(_vm._s(p.val))])}),(_vm.currentPage !== _vm.totalPages)?_c('router-link',{staticClass:"pagination__item pagination__item--next",attrs:{"to":_vm.mkRouteObj(++_vm.currentPage)}},[_c('i',{staticClass:"fal fa-chevron-right"})]):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }